module.exports = __webpack_public_path__ + "media/images/contact_name_icon-46a155ab.svg";